import React from 'react';
import { CollapsibleDetailsSection } from '../../components';
import { TERMINAL_PROFILE_DETAILS } from '@shared/data/mockTerminalsPanels';

interface ProfileSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  isDetailView?: boolean;
  className?: string;
}

export const ProfileSection = React.memo<ProfileSectionProps>(({ isExpanded, onToggle, isDetailView = false, className }) => {
  const handleUpdate = () => {
    console.log('Update profile clicked');
    // Add your update logic here
  };

  const actions = [
    {
      label: 'Update',
      onClick: handleUpdate
    }
  ];

  return (
    <CollapsibleDetailsSection
      title="Profile"
      details={TERMINAL_PROFILE_DETAILS}
      isExpanded={isExpanded}
      onToggle={onToggle}
      isDetailView={isDetailView}
      emptyMessage="No profile details available"
      actions={actions}
      className={className}
    />
  );
});

ProfileSection.displayName = 'ProfileSection';